<template>
  <div class="helpCenter">
      <!-- 顶部banner -->
      <div class="helpBanner" :style="{height:backgroundImg}">
          <img
            src="../../assets/image/helpCenter.jpg"
            alt=""
            ref="backgroundHelp"
        >
          <div class="helpBanner_box">
              <div class="flex helpBanner_boxSearch">
                  <h3>帮助中心</h3>
                  <el-input placeholder="请输入内容" v-model="helpCenterInput">
                    <el-button slot="append" icon="el-icon-search" @click="searchInput()"></el-button>
                  </el-input>
              </div>
              <div class="flex helpBanner_mess">
                  <div class="flex helpBanner_messBox"  v-for="(wordInfo, index) in recommendList" :key="index">
                      <i class="iconfont vHtmlMess" v-html="iconList[index]"></i>
                      <div class="messBox_text">
                          <h3 v-html="wordInfo.title" @click="handleHelpDetail(wordInfo)"></h3>
                          <p v-html="wordInfo.remark" class="vHtmlMess"></p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- 下方列表 -->
      <div class="helpMessList">
          <div class="flex helpMessList_mess" v-for="(list, index) in helpMessList" :key="index">
              <h4>{{list.title}}</h4>
              <div class="helpMessList_messList">
                  <p
                    v-for="( listM,indexM) in list.listMess"
                    :key="indexM"
                    @click="handleHelpDetail(listM)"
                  >{{listM.title}}</p>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import {findWordInfoList,findWordInfoByRecommend} from "../../utils/wordInfo";

export default {
    name: "heplCenter",
    data(){
        return {
            helpCenterInput: '',
            helpMessList: [],
            backgroundImg: '',
            setIn: null,
            recommendList:[],
            iconList:['&#xe606;','&#xeb48;','&#xe604;','&#xe603;']
        }
    },
    created(){
        this.getWordInfoList();
        this.findWordInfoByRecommend();
        this.setIn = setInterval(() => {
            if (this.$store.state.isTokenDoor === true) {
                clearInterval(this.setIn);
                this.handleBackground()
            }
        }, 500);

    },
    methods:{
        // 获取背景图的高度
        handleBackground() {
            this.backgroundImg = this.$refs.backgroundHelp.offsetHeight + 'px'
            // console.log('imgs',this.$refs.backgroundHelp.offsetHeight );

        },
        getWordInfoList(){
            let params = {
                title: this.helpCenterInput,
            };
            findWordInfoList(params).then((res)=>{
                this.helpMessList = res
                // console.log(JSON.stringify(res))
            })

        },
        // 跳转详情
        handleHelpDetail(val){
            // this.$router.push({name:'helpCenterDetail',params:{wordNo:val.wordNo}});
            this.$router.push('/helpCenterDetail?wordNo='+val.wordNo);
        },
        searchInput(){
            this.getWordInfoList();
        },
        findWordInfoByRecommend(){
            let params = {
                recommend: "0",
            };
            findWordInfoByRecommend(params).then((res)=>{
                if(res.data.length > 4){
                    this.recommendList = res.data.slice(0,4);

                }else {
                    this.recommendList = res.data;
					console.log(res.data,222222)
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.helpCenter {
    .helpBanner {
        width: 100%;
        position: relative;
        img {
            width: 100%;
        }
        .helpBanner_box {
            position: absolute;
            top: 56%;
            left: 50%;
            transform: translate(-50%,-50%);
            .helpBanner_boxSearch {
                margin-bottom: 150px;
                align-items: center;
                justify-content: center;
                h3 {
                    font-size: 36px;
                    color: #FFFFFF;
                    margin-right: 34px;
                }
                /deep/.el-input {
                    width: 538px;
                    height: 40px;
                    border-radius: 10px 0 0 10px;
                }
                /deep/.el-input__inner {
                    border: none;
                    background: #FDFDFD;
                    opacity: 0.54;
                }
                /deep/.el-input-group__prepend {
                    background-color: #fff;
                }
                /deep/.el-input-group__append button.el-button {
                    width: 80px;
                    height: 40px;
                }
                /deep/.el-input-group__append {
                    background: #009999;
                    color: #fff;
                    font-size: 20px;
                    border-radius: 0 10px 10px 0;
                    border: none;
                }
            }
            .helpBanner_mess {
                align-items: center;
                .helpBanner_messBox {
                    width: 274px;
                    height: 90px;
                    cursor: pointer;
                    background: #FFFFFF;
                    border-radius: 10px;
                    align-items: center;
                    justify-content: center;
                    margin-right: 40px;
                    padding: 0 24px;
                    box-sizing: border-box;
                    &:nth-last-of-type(1){
                        margin-right: 0;
                    }
                    i {
                        font-size: 43px;
                    }
                    .messBox_text {
                        margin-left: 12px;
                        color: #5D5D5D;
                        h3 {
                            font-size: 18px;
                            margin-bottom: 2px;
                        }
                        p {
                            font-size: 12px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                        }
                    }
                }
            }
        }
    }
    .helpMessList {
        width: 1200px;
        margin: 0 auto;
        .helpMessList_mess {
            border-bottom: 1px solid #efefef;
            padding-top: 30px;
            padding-bottom: 10px;
            h4 {
                font-size: 16px;
                color: #009999;
                width: 86px;
                margin-right: 115px;
                flex-shrink: 0;
            }
            .helpMessList_messList {
                display: flex;
                flex-wrap: wrap;
                font-size: 14px;
                color: #414141;
                width: 1114px;
                p {
                    margin-bottom: 20px;
                    // width: 298px;
                    width: 25%;
                    cursor: pointer
                }
                p:hover{
                    color:#009999;
                }
            }
             
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/helpCenter/helpCenter.vue